import React from 'react';
import { X } from 'lucide-react-native';
import {
  HStack,
  Icon,
  Pressable,
  Text,
} from '@gluestack-ui/themed';

type ReferencePillProps = {
  label: string;
  testID: string;
  onRemove?: () => void;
  removeTestID?: string;
  removeLabel?: string;
};

/**
 * A chosen reference, shown as a pill. The name is not an editable field.
 * The X, when present, sits inside the pill.
 */
const ReferencePill: React.FC<ReferencePillProps> = ({
  label,
  testID,
  onRemove,
  removeTestID,
  removeLabel,
}) => (
  <HStack
    testID={testID}
    alignItems="center"
    alignSelf="center"
    space="xs"
    bg="$bgBrandSubtle"
    borderRadius="$full"
    px="$2"
    py="$1"
  >
    <Text size="xs" color="$textBrand" fontFamily="$heading" numberOfLines={1}>
      {label}
    </Text>
    {onRemove ? (
      <Pressable
        testID={removeTestID}
        onPress={onRemove}
        hitSlop={8}
        accessibilityLabel={removeLabel}
      >
        <Icon as={X} size="xs" color="$textBrand" />
      </Pressable>
    ) : null}
  </HStack>
);

export default ReferencePill;
